import React from "react";
import "./Calendar.css";

const Calendar = ({ label, value, onChange, required = false, error, valid }) => {
  const formatForInput = (dateString) => {
    if (!dateString) return '';
    if (dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dateString;
  };

  const handleChange = (e) => {
    const inputDate = e.target.value;
    if (inputDate) {
      const [year, month, day] = inputDate.split('-');
      onChange(`${day}/${month}/${year}`);
    } else {
      onChange('');
    }
  };

  return (
    <div className="calendar-container">
      {label && (
        <label className="calendar-label">
          {label}{required && <span className="required-star"> *</span>}
        </label>
      )}
      <input
        type="date"
        className={`calendar-input ${error ? 'calendar-input-error' : valid ? 'calendar-input-valid' : ''}`}
        value={formatForInput(value)}
        onChange={handleChange}
        required={required}
        max={new Date().toISOString().split('T')[0]}
      />
      {error && <div className="calendar-error">{error}</div>}
    </div>
  );
};

export default Calendar;
